import { render } from "./SwitchRoles.vue?vue&type=template&id=469d6846"
import script from "./SwitchRoles.vue?vue&type=script&lang=ts"
export * from "./SwitchRoles.vue?vue&type=script&lang=ts"
script.render = render

export default script